import { HTMLAttributes } from 'react';

export const ArrowRightIcon = (props: HTMLAttributes<SVGElement>): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1rem"
      height="1rem"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M2 10H16M16 10L10.1667 4.5M16 10L10.1667 15.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
